import { flattenUser } from '../lib/helpers';
import {
	filterTypenameFromObject,
	RecursivePartial,
} from '../lib/helpers/apollo';
import { AuthedUser } from '#types';

/**
 * A helper to mimic the internal-transform within API.getAuthedUser for Apollo methods
 * Unlike API.getAuthedUser this does not return { user, groups }, just the user, as groups is currently unused
 */
type AuthedUserShape = RecursivePartial<AuthedUser>;
export const transformGetAuthedUserForRedux = <T extends AuthedUserShape>(
	user: T
) => {
	// "pre-flatten" the user
	const transformedUser = {
		...user, // i guess we start the object with the user...
		user, // ...and also we stick the original user into a prop...the redux user is weird...
		...( user.orgUser || user.clientUser || user.superAdmin ),
	};
	return flattenUser(
		filterTypenameFromObject( {
			...transformedUser,
			...( user.impersonatingUser
				? { impersonatingUser: user.impersonatingUser }
				: undefined ),
		} ),
		user.groups
	);
};
